<div class="modal-header blocked-slot-header px-0">

    <div class="d-flex flex-grow-1">
        <div class="flex-grow-1 justify-content-end">
            <div>
                <h5 class="modal-title text-leftt">{{'BlockedSlotSave.Title' | translate}} </h5>
            </div>
        </div>
        <div class="flex-grow-1 d-flex justify-content-end">
            <button type="button" data-dismiss="modal" aria-label="Close" (click)="bsModalRef.hide()"
                class="btn btn-light-blue-outline btn-sm">{{'General.Cancel' | translate}}</button>

            <button type="button" (click)="onSave()" [disabled]="!(isFormValid$ | async)"
                class="btn btn-light-blue btn-sm ml-2">{{'BlockedSlotSave.Save' | translate}}</button>
        </div>
    </div>

</div>
<div class="modal-body bay-club-light-blue-2-bg">
    <bcu-local-spinner [size]="40" [visible]="(showSpinner$ | async)" *ngIf="(showSpinner$ | async)">
    </bcu-local-spinner>
    <div class="blocked-slot-content">
        <form [formGroup]="form" novalidate *ngIf="form && !(saveSpinner$ | async).visible"
            ngxsForm="blockedSlotSave.form">

            <div class="row">
                <div class="col">
                    <label for="clubId">{{'BlockedSlotSave.Club' | translate}}</label>

                    <bcu-drop-down-cf2 maxHeigth="450" formControlName="clubId" [options]="(clubs$ | async)?.items"
                        (changed)="onClubsChanged($event)" valueKey="id" displayKey="name">
                    </bcu-drop-down-cf2>
                </div>
                <div class="col">
                    <label for="type">{{'BlockedSlotSave.EventType' | translate}}</label>

                    <bcu-drop-down-cf2 maxHeigth="450" formControlName="typeCode"
                        [options]="(blockedSlotTypes$ | async)?.items" valueKey="code" displayKey="name">
                    </bcu-drop-down-cf2>
                </div>
            </div>

            <div class="row mt-3">
                <div class="col-5">
                    <label for="date">{{'BlockedSlotSave.Date' | translate}}</label>
                    <bcui-date-picker-input id="date" [form]="form.controls.date" [inputDateFormat]="'MM/DD/YYYY'"
                        [inputMask]="'00/00/0000'"></bcui-date-picker-input>
                </div>
                <div class="col">
                    <label for="timeFromInMinutes">{{'BlockedSlotSave.StartTime' | translate}}</label>
                    <app-time-picker name="timeFromInMinutes" formControlName="timeFromInMinutes">
                    </app-time-picker>
                </div>

                <div class="col">
                    <label for="timeToInMinutes">{{'BlockedSlotSave.EndTime' | translate}}</label>
                    <app-time-picker name="timeToInMinutes" formControlName="timeToInMinutes">
                    </app-time-picker>
                </div>
            </div>

            <div class="row mt-3">
                <div class="col">
                    <label for="courtId">{{'BlockedSlotSave.CourtName' | translate}}</label>

                    <bcu-drop-down-cf2 [isDisabled]="!(isDateSelected$ | async)" maxHeigth="450"
                        formControlName="courtId" [options]="(clubCourts$ | async)?.items" valueKey="courtId"
                        displayKey="name">
                    </bcu-drop-down-cf2>
                </div>
                <div class="col">
                    <label for="recurring">{{'BlockedSlotSave.Recurring' | translate}}</label>
                    <bc-recurring [startDate]="form.controls['date'].value" [disabled]="!startDateSelected"
                        formControlName="recurring"></bc-recurring>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col">
                    <div class="form-group">
                        <label for="note">{{'BlockedSlotSave.Note' | translate}}</label>

                        <textarea rows="3" class="form-control" formControlName="note" maxlength="4000"></textarea>
                    </div>

                </div>
            </div>
        </form>
    </div>
</div>